import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-pick-a-dentist',
  templateUrl: './pick-a-dentist.component.html',
  styleUrls: ['./pick-a-dentist.component.css']
})
export class PickADentistComponent implements OnInit {

  constructor(
    private appService:AppService
  ) { }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.appService.inPickADentistMode.next(false);
  }

}
